export default {
  shoppingCartView: {
    title: 'Shopping Cart',
    agencyProductsSubtitle: 'Agency products',
    boutiqueProductsSubtitle: 'Shop products',
    reservedProductsSubtitle: 'Reserved',
  },
  shoppingCartEmptyView: {
    infoPar1Span1: 'Your shopping cart is empty. If you are thirsty, fill it up by exploring the product selection offered through the ',
    infoPar1Span2: 'Montreal Shop,',
    infoPar1Span3: ' or ',
    infoPar1Span4: 'agency',
    infoPar1Span5: '.',
    infoPar1Span7: ' Shop Quebec',
    infoPar2Span1: 'Psst, you can also find ',
    infoPar2Span2: '',
    infoPar2Span3: ' takeout food items and other ',
    infoPar2Span4: 'related products',
    infoPar2Span5: '.',
    infoPar1Span8: '  Toronto Shop',
  },
  shoppingCartSummaryComponent: {
    summary: 'Summary',
    agency: 'Agency',
    agencyFees: 'Agency fees',
    saqFees: 'SAQ fees',
    subTotal: 'Paid at the Saq',
    payNow: 'Pay now',
    boutique: 'Shop',
    tps: 'GST',
    tvq: 'QST',
    hst: 'HST',
    total: 'Total',
    toPaySaq: 'To be paid at the SAQ (+ tx.)',
    toPayNow: 'Subtotal',
    ctaOrder: 'Order',
  },
  shoppingCartAuthModel: {
    placeOrder: 'Placing an order',
    guestOrder: 'Ordering as a guest',
    register: 'Already registered?',
    registerNow: 'Register now',
    signIn: 'Sign in',
    continue: 'Continue',
  }
};
